/**
 * 2026-09-08 [신설] 네이티브 앱이 «차단망» 사실을 웹에 알려주는 창구.
 *
 * ## 왜 필요한가
 * 중국 등에서는 구글·페이스북 계열 도메인이 통째로 막혀, 스크립트를 요청해도 에러가 아니라
 * **응답 없이 타임아웃**된다. 웹은 그 사실을 «오래 기다린 뒤에야» 알 수 있지만,
 * 앱은 자기가 시도한 구글 접속의 타임아웃으로 **먼저** 안다. 그 정보를 웹으로 넘겨받아
 * 막힐 것이 뻔한 UI(예: 페이스북 공유 버튼)를 처음부터 그리지 않기 위한 것이다.
 *
 * ## 앱이 호출하는 방법 (앱팀 연동 규약)
 * 웹뷰에서 아래 한 줄을 실행하면 된다. 안드로이드는 `evaluateJavascript`,
 * iOS 는 `evaluateJavaScript` 로 호출한다.
 *
 * ```js
 * window.dySetNetworkConnectFailed(true)
 * ```
 *
 * - 인자를 생략하면 `true` 로 간주한다.
 * - 되돌리려면 `window.dySetNetworkConnectFailed(false)`.
 * - **아무 때나 불러도 된다.** 이 플러그인은 앱보다 먼저 뜨는 것을 보장하지 않으므로,
 *   앱이 페이지 로드 직후 호출했다가 실패하면 잠시 뒤 한 번 더 부르는 편이 안전하다.
 *
 * ## 함정
 * 🔴 이 함수는 **존재 여부로 앱을 판별하는 용도가 아니다.** 모든 브라우저에 정의된다.
 * 🔴 값은 sessionStorage 에 영속된다(archive 스토어). 탭이 살아 있는 동안 유지되고
 *    탭을 닫으면 사라진다 — 중국을 벗어난 사용자가 영영 갇히지 않게 하기 위함이다.
 */
import { useDYArchiveStore } from "../stores/archive"

export default defineNuxtPlugin(() => {
  if (!import.meta.client) return

  const archiveStore = useDYArchiveStore()

  // 이전 페이지에서 이미 확인된 값이 있으면 되살린다(sessionStorage).
  archiveStore.restoreNetworkConnectFailed()

  window.dySetNetworkConnectFailed = (failed: boolean = true) => {
    archiveStore.setNetworkConnectFailed(!!failed)
  }
})
